module.exports = __webpack_public_path__ + "media/images/svg/linkedin-8be8a196a05265809cc8878c94b4816e.svg";